<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link v-if="!this.checkRegist" class="navbar-brand" :to="navBarRoutePath"></b-link>
    <b-link v-else class="navbar-brand"></b-link>

    <b-navbar-nav v-if="!this.checkRegist" class="ml-auto">
      <b-nav-item class="px-5" @click="onClick1on1Req" v-if="hasUnread1on1Req"><i class="fa fa-envelope"></i> {{ hasUnread1on1Req }}</b-nav-item>
      <HeaderDropdown/>
      <b-nav-item class="px-5" @click="onClickHelp"><i class="fa fa-question-circle"></i></b-nav-item>
      <TransLangDropdown/>
      <b-nav-item class="px-5" @click="logOut"><i class="fa fa-sign-out"></i> {{$t('logOutString')}}</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav v-else class="ml-auto">
      <TransLangDropdown/>
      <!-- <b-nav-item class="px-5" @click="logOut"><i class="fa fa-sign-out"></i> {{$t('logOutString')}}</b-nav-item> -->
    </b-navbar-nav>

  </header>
</template>
<script>
  import HeaderDropdown from './HeaderDropdown.vue'
  import TransLangDropdown from './TransLangDropdown.vue'
  import { routePath } from '@/main.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'c-header',
    components: {
      HeaderDropdown,
      TransLangDropdown
    },
    data: function () {
      return {
        routePath: routePath,
        regist: false
      }
    },
    computed: {
      ...mapGetters('ones/', [
        'getCurrent1on1RequestsReceivedUnread'
      ]),
      hasUnread1on1Req () {
        // console.log('hasUnread1on1Req:', this.getCurrent1on1RequestsReceivedUnread)
        return (this.getCurrent1on1RequestsReceivedUnread || []).length
      },
      checkRegist: {
        get () {
          return this.regist
        },
        set (value) {
          this.regist = value
        }
      },
      navBarRoutePath () {
        return '../' + routePath
      }
    },
    mounted: function () {
      console.log('route in header in mounted', this.$route.name)
      if (this.$route.name === 'ProfileRegist') {
        this.checkRegist = true
      } else {
        this.checkRegist = false
      }
    },
    // updated: function () {
    //   console.log('route in header in updated', this.$route.name)
    //   if (this.$route.name === 'ProfileRegist') {
    //     this.regist = true
    //   } else {
    //     this.regist = false
    //   }
    // },
    // beforeRouteUpdate: function (to, from, next) {
    //   console.log('beforeRouteUpdate in head', to.name)
    // },
    methods: {
      ...mapActions({
        destroySession: 'destroySession'
      }),
      // ...mapActions('okrs/', {
      //   unBindCurrentObjectives: 'unBindCurrentObjectives'
      // }),
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      // },
      // asideToggle (e) {
      //   e.preventDefault()
      //   document.body.classList.toggle('aside-menu-hidden')
      },
      logOut (e) {
        this.$swal({
          title: this.$t('popMessageStr19'),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 5000
        }).then((result) => {
          if (result.value) {
            console.log('*** Log Out ***')
            // this.unBindCurrentObjectives()
            // this.destroySession().then(() => {
            //   conosle.log('destroy state:::')
            // })
            // this.destroySession()
            //   .then(() => this.$firebase.auth().signOut())
            //   .then((user) => {
            //     console.log('destroy state:::')
            //     // console.log('LogOut: ', user)
            //     this.$router.replace({ name: 'Login' })
            //   })
            this.$firebase.auth().signOut()
              .then((user) => this.destroySession())
              .then(() => {
                console.log('destroy state:::')
                // console.log('LogOut: ', user)
                this.$router.replace({ name: 'Login' })
              })
          }
        })
      },
      onClick1on1Req: function () {
        this.$router.push({ name: 'OneRequestRece' })
      },
      onClickHelp: function () {
        this.$router.push({ name: 'Help' })
      },
      onChangeHidden: function (profileRegist) {
        if (profileRegist) this.checkRegist = true
        else this.checkRegist = false
      }
    }
  }
</script>
<style scoped>
  .hidden {
    visibility: hidden;
  }
  .app-header.navbar .navbar-brand{
    background-size: 90% auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue